<template>
  <base-nav container-classes="container-fluid" class="navbar-top border-bottom navbar-expand fixed-top p-1 "
    :class="[headerColorClass, { 'navbar-dark': type === 'default' }]">
    <!-- Search form -->
    <form class="navbar-search form-inline mr-sm-3" :class="{
      'navbar-search-light': type === 'default',
      'navbar-search-dark': type === 'light',
    }" id="navbar-search-main">
      <div class="form-group mb-0">
      </div>
      <button type="button" class="close" data-action="search-close" data-target="#navbar-search-main"
        aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
    </form>
    <!-- Navbar links -->
    <ul class="navbar-nav align-items-center ml-md-auto">
      <li class="nav-item">
        <a class="nav-link disabled-mouse-over" href="#">
          <span v-if="isTickDelayedStatus" class="mb-0 text-lg font-weight-boldr">{{ tickStatusText
          }}</span>
          <i v-else class="fas fa-stopwatch text-white disabled-mouse-over"></i>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link enabled-action" @click="handlePauseStatus">
          <i v-if="!pauseStatus" class="fas fa-play text-white"></i>
          <i v-else class="fas fa-pause bg-danger-pause"></i>
        </a>
      </li>
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div class="pr-3 sidenav-toggler" :class="{
          active: $sidebar.showSidebar,
          'sidenav-toggler-dark': type === 'default',
          'sidenav-toggler-light': type === 'light',
        }" @click="toggleSidebar">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
    </ul>
    <ul v-if="impUserId" class="navbar-nav align-items-center ml-auto ml-md-0">
      <a href="#" class="nav-link pr-0  disabled-mouse-over" @click.prevent>
        <div class="media align-items-center">
          <div class="media-body d-none d-lg-block">
            <span class="mb-0 text-sm text-white font-weight-bold">{{ impUserName }}</span>
          </div>
        </div>
      </a>
      <i class="fas fa-running fa-lg text-white ml-2" @click="removeImpersonate()"></i>
    </ul>
    <ul v-if="!impUserId" class="navbar-nav align-items-center ml-auto ml-md-0">
      <base-dropdown menu-on-right class="nav-item" tag="li" title-tag="a" title-classes="nav-link pr-0">
        <template v-slot:title-container>
          <a href="#" class="nav-link pr-0" @click.prevent>
            <div class="media align-items-center">
              <span class="avatar avatar-sm rounded-circle">
                <img v-if="userPhoto" :src="userPhoto" alt="Profile Photo" />
              </span>
            </div>
          </a>
        </template>
        <div class="dropdown-header noti-title">
          <h6 class="text-overflow m-0">Welcome, <b>{{ userName }}</b></h6>
        </div>
        <div class="dropdown-divider"></div>
        <a href="javascript:void(0)" @click="signOut()" class="dropdown-item">
          <i class="ni ni-user-run"></i>
          <span>Logout</span>
        </a>
      </base-dropdown>
    </ul>
  </base-nav>
  <div
    class="fixed-info-bar border-bottom mt-5 pt-1 top-0 z-index-4 sticky-top position-fixed shadow-lg bg-white w-100">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-4 col-md-6 d-flex align-items-center flex-nowrap">
          <div class="container-fluid">
            <div class="row no-gutters align-items-center ml-4 ml-md-0">
              <div class="col-auto font-weight-bold text-dark no-message">NIFTY:</div>
              <div
                :class="['col-3 col-md-3 text-left text-dark no-message ml-2 mr-md-3', getMarketColor(niftyValue), niftyValue > 0 ? 'col-xl-2' : 'col-xl-auto']">
                {{ niftyValue }}
              </div>
              <div class="col-auto font-weight-bold text-dark no-message ml-2">SENSEX:</div>
              <div class="col-xl-2 col-3 col-md-3 text-left text-dark no-message ml-2"
                :class="getMarketColor(sensexValue)">
                {{ sensexValue }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 d-flex align-items-center flex-nowrap">
          <div class="d-flex justify-content-center align-items-center w-100 justify-content-md-end mr-md-5">
            <div class="text-dark mr-3">
              <i class="fas fa-calendar-days no-message"></i>
              <span class="font-weight-bold no-message ml-1">{{ commonDate }}</span>
            </div>
            <div class="d-flex align-items-center text-dark mr-3">
              <i class="fas fa-calendar-check no-message"></i>
              <span class="p-1 font-weight-bold no-message">{{ tickTime }}</span>
            </div>
            <div class="d-flex align-items-center text-dark">
              <i class="fas fa-clock no-message"></i>
              <span class="p-1 font-weight-bold no-message">{{ currentTime }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseNav from "@/components/Navbar/BaseNav";
import { registerSubscriber, disconnect, send } from '../../views/System/statusWebsocket';
import { emitter, getDataFromStorage } from '../System/emitter';
import moment from "moment";

export default {
  components: {
    BaseNav,
  },
  props: {
    type: {
      type: String,
      default: "default", // default|light
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)",
    },
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    headerColorClass() {
      if (this.impUserId && !this.isTickDelayedStatus) {
        return 'bg-navhead';
      }
      else if (this.impUserId && this.isTickDelayedStatus) {
        return 'userImp-blinking';
      }
      else if (!this.impUserId && this.isTickDelayedStatus) {
        return 'blinking-effect';
      } else {
        return 'bg-primary';
      }
    },
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
      pauseStatus: false,
      statusCommand: "statusPaused",
      tickStatusText: "",
      tickCommand: "lastTick",
      indexCommand: "indexTick",
      tickMessage: null,
      data: getDataFromStorage(),
      impUserId: getDataFromStorage().userId,
      impUserName: getDataFromStorage().name,
      isTickDelayedStatus: false,
      tickStatusText: '',
      userName: '',
      userPhoto: '',
      niftyValue: "---",
      sensexValue: "---",
      currentTime: "",
      tickTime: "---",
      commonDate: this.formatDate(new Date()),
      statusInterval: null,
      tickInterval: null,
      indexTick: null,
      pauseStatusRaw: null,
    };
  },
  created() {
    registerSubscriber(this.onMessageReceived);
    setInterval(() => {
      send(this.statusCommand);
    }, 30000);
    setInterval(() => {
      send(this.indexCommand);
    }, process.env.VUE_APP_LAST_TICK_REQUEST_INTERVAL);
    setInterval(() => {
      send(this.tickCommand);
    }, process.env.VUE_APP_LAST_TICK_REQUEST_INTERVAL);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    disconnect();
    if (this.statusInterval) {
      clearInterval(this.statusInterval);
    }
    if (this.tickInterval) {
      clearInterval(this.tickInterval);
    }
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    onMessageReceived(receivedMessage) {
      if (receivedMessage.command === 'statusPaused') {
        const response = receivedMessage.response;
        this.pauseStatusRaw = response;
        this.pauseStatus = !!(response && response.trim() !== '');
      } else if (receivedMessage.command === 'lastTick') {
        this.tickMessage = receivedMessage.response;
        this.tickTime = this.formatDateTime(this.tickMessage);
        this.isTickDelayed()
      } else if (receivedMessage.command === 'indexTick') {
        this.indexTick = receivedMessage.response;
        this.getIndex()
      }
    },
    formatDateTime(dateTimeString) {
      if (!dateTimeString) return "--";
      return moment(dateTimeString).format("hh:mm:ss");
    },
    removeImpersonate() {
      this.impUserId = '';
      sessionStorage.removeItem('storedData');
      emitter.emit('flag-sent', { userId: this.impUserId });
    },
    isTickDelayed() {
      console.log("isTickDelayed has invoked");
      this.tickStatusText = '';
      this.isTickDelayedStatus = false;
      if (this.tickMessage) {
        const tickDate = new Date(this.tickMessage);
        const currentDate = new Date();
        const currentHour = currentDate.getHours();
        const currentMinute = currentDate.getMinutes();
        const isWithinTimeRange = (currentHour > 9 || (currentHour == 9 && currentMinute >= 15)) &&
          (currentHour < 23 || (currentHour == 23 && currentMinute <= 45));
        if (!isWithinTimeRange) {
          this.isTickDelayedStatus = false;
          return;
        }
        const timeDifference = Math.floor((currentDate - tickDate) / (1000 * 60));
        console.log("The tickDate is :", tickDate)
        console.log("The currentDate is :", currentDate)
        console.log("The timeDifference is :", timeDifference)
        if (timeDifference < 1 && timeDifference > 0) {
          this.tickStatusText = '< 1';
          this.isTickDelayedStatus = true;
        } else if (timeDifference >= 1 && timeDifference <= 9) {
          this.tickStatusText = '~ 7';
          this.isTickDelayedStatus = true;
        } else if (timeDifference > 9) {
          this.tickStatusText = '> 9';
          this.isTickDelayedStatus = true;
        } else {
          this.isTickDelayedStatus = false;
        }
      } else {
        this.isTickDelayedStatus = false;
      }
    },
    signOut() {
      this.$store
        .dispatch("authStore/signOut", { root: true })
        .then(
          sessionStorage.removeItem("accessToken"),
        ).catch(function (error) {
          console.log(error);
        });
    },
    async fetchProfileToken() {
      try {
        this.userPhoto = await this.$store.dispatch("profileStore/getUserProfile", { root: true });
      } catch (error) {
        console.log(error);
      }
    },
    getMarketColor(value) {
      if (value > 0) {
        return "text-green";
      } else if (value < 0) {
        return "text-red";
      } else {
        return "text-gray";
      }
    },
    formatTime(date) {
      return moment(date).format("hh:mm:ss");
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    updateTime() {
      const now = new Date();
      this.currentTime = this.formatTime(new Date());
      this.commonDate = this.formatDate(new Date());
    },
    getIndex() {
      let marketData = this.indexTick;
      this.niftyValue = (marketData.NIFTY && marketData.NIFTY.price)
        ? marketData.NIFTY.price
        : "--";
      this.sensexValue = (marketData.SENSEX && marketData.SENSEX.price)
        ? marketData.SENSEX.price
        : "--";
    },
    handlePauseStatus() {
      if (!this.pauseStatus) return;
      sessionStorage.setItem('pause-status-response', this.pauseStatusRaw);
      this.$router.push({ name: 'PausedStatus' });
    }
  },
  mounted: async function () {
    await this.fetchProfileToken();
    const account = JSON.parse(sessionStorage.getItem("userAccount"));
    if (account) {
      this.userName = account.name;
    }
    emitter.on('data-sent', (data) => {
      this.data = data;
      this.impUserId = this.data.userId;
      this.impUserName = this.data.name;
    });
    this.updateTime();
    this.timer = setInterval(this.updateTime, 1000);
  },
};
</script>
<style></style>
